// extracted by mini-css-extract-plugin
export default {"authorization":"Authorization_authorization__Ex2r6","logo":"Authorization_logo__3HNY4","loginButton":"Authorization_loginButton__R9QUQ"};